<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.otpList.otpList") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg class="flex-shrink-0 w-6 h-full text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link :to="page.href" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined">{{ page.name }}</router-link>
          </div>
        </li>
      </ol>
    </nav>

    <!-- <div class="px-8 py-6" v-show="!isLoaded">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center"
      >
        <font-awesome-icon
          class="text-gray-500"
          :icon="['fas', 'circle-notch']"
          transform="grow-6"
          spin
        />
      </div>
    </div> -->

    <div class="py-6">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow overflow-x-auto sm:rounded-md">
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
            <div v-if="!isLoaded"
              class="absolute inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50">
              <div class="loader"></div>
              <p class="text-gray-700 text-lg">Loading...</p>
            </div>
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t("messages.otpList.phoneNumber") }}
                  </th>

                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    {{ $t("messages.otpList.refcode") }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    {{ $t("messages.otpList.otp") }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    {{ $t("messages.otpList.isVerified") }}
                  </th>
                  <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                    {{ $t("messages.otpList.createdAt") }}
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="data in dataRows" :key="data.id" class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ data.phoneNumber }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{ data.refCode }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{ data.otp }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    <font-awesome-icon v-if="data.isVerified" class="text-green-600" :icon="['fas', 'check-circle']" />
                    <font-awesome-icon v-if="!data.isVerified" class="text-blue-600" :icon="['fas', 'times-circle']" />
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ dayjs(data.createdAt).locale("th").format("LLL") }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
              <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                <div>
                  <Listbox as="div" v-model="rowsPerPage">
                    <ListboxButton
                      class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                      <span class="block truncate">{{
                        rowsPerPage.value
                      }}</span>
                      <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </span>
                    </ListboxButton>
                    <ListboxOptions
                      class="absolute z-10 mt-1 w-44 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                      <ListboxOption as="template" v-for="(option, index) in rowsPerPageOption" :key="index"
                        :value="option" @click="refetch">
                        <li :class="[
                          'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                        ]">
                          <span :class="[
                            option.value == rowsPerPageOption.value
                              ? 'font-semibold'
                              : 'font-normal',
                            'block truncate text-left',
                          ]">
                            {{ option.label }}
                          </span>

                          <span v-if="option.value == rowsPerPageOption.value" :class="[
                            'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                          ]">
                            <CheckIcon class="h-5 w-5" aria-hidden="true" />
                          </span>
                        </li>
                      </ListboxOption>
                    </ListboxOptions>
                  </Listbox>
                  <p class="text-sm text-gray-700">
                    {{ $t("messages.otpList.showing") }}
                    {{ " " }}
                    <span class="font-medium">{{ offset + 1 }}</span>
                    {{ " " }}
                    {{ $t("messages.otpList.to") }}
                    {{ " " }}
                    <span class="font-medium">{{
                      offset + dataRows.length
                    }}</span>
                    {{ " " }}
                    {{ $t("messages.otpList.of") }}
                    {{ " " }}
                    <span class="font-medium">{{ dataCount }}</span>
                    {{ " " }}
                    {{ $t("messages.otpList.results") }}
                  </p>
                </div>
              </div>
              <div>
                <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                  <a href="javascript:void(0)" @click="jump(1)"
                    class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                    <span class="sr-only">First</span>
                    <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500"
                        :icon="['fas', 'chevron-double-left']" transform="shrink-2" /></span>
                  </a>
                  <a href="javascript:void(0)" @click="prev"
                    class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                    <span class="sr-only">Previous</span>
                    <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500"
                        :icon="['fas', 'chevron-left']" transform="shrink-2" /></span>
                  </a>
                  <a href="javascript:void(0)" @click="jump(i)" v-for="i in pageCount()" :key="i" :class="currentPage === i
                      ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
                      : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
                    " :style="{
                      display:
                        Math.abs(i - currentPage) < 2 || i == 0
                          ? 'block'
                          : 'none',
                    }" style="cursor: pointer">
                    {{ i }}
                  </a>
                  <a href="javascript:void(0)" @click="next"
                    class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                    <span class="sr-only">Next</span>
                    <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500"
                        :icon="['fas', 'chevron-right']" transform="shrink-2" /></span>
                  </a>
                  <a href="javascript:void(0)" @click="jump(Math.ceil(dataCount / rowsPerPage.value))"
                    class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                    <span class="sr-only">Last</span>
                    <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500"
                        :icon="['fas', 'chevron-double-right']" transform="shrink-2" /></span>
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/vue/solid";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import "dayjs/locale/th";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";

dayjs.extend(localizedFormat);

const pages = [{ name: "OTP List", href: "", current: true }];
const rowsPerPageOption = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "30", value: 30 },
  { label: "40", value: 40 },
];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    CheckIcon,
    SelectorIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const fromDate = ref("");
    const toDate = ref("");
    const currentPage = ref(1);
    const offset = ref(0);
    const rowsPerPage = ref({ label: "10", value: 10 });
    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);

    onMounted(() => {
      refetch();
    });

    const refetch = () => {
      isLoaded.value = false;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/operator-admin/user/list-otp/pagination",
          {
            operatorId: store.state.selectedOperator.operatorId,
            page: currentPage.value - 1,
            pageSize: rowsPerPage.value.value,
            offset: offset.value,
            sortBy: [["createdAt", -1]],
          }
        )
        .then(({ data }) => {
          dataRows.value = data.result.rows;
          dataCount.value = data.result.count;
          isLoaded.value = true;
        })
        .catch(({ response }) => {
          isLoaded.value = true
        });
    };

    const pageCount = () =>
      Math.ceil(dataCount.value / rowsPerPage.value.value);

    const prev = () => {
      if (currentPage.value - 1 >= 1) {
        currentPage.value -= 1;
        offset.value = (currentPage.value - 1) * rowsPerPage.value.value;
        refetch();
      }
    };

    const next = () => {
      if (currentPage.value + 1 <= pageCount()) {
        offset.value = rowsPerPage.value.value * currentPage.value;

        refetch();
        currentPage.value += 1;
      }
    };

    const jump = (page) => {
      currentPage.value = page;
      offset.value = (page - 1) * rowsPerPage.value.value;
      refetch();
    };

    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.id } });
    };

    return {
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      fromDate,
      toDate,
      route,
      prev,
      next,
      viewData,
      pageCount,
      refetch,
      jump,
      pages,
      rowsPerPageOption,
      rowsPerPage,
      currentPage,
      offset,
    };
  },
};
</script>
